import { Box, Typography } from '@mui/material'

export function TabPanel(props: any) {
  const { children, value, index, flush, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index &&
        (flush ? (
          children
        ) : (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        ))}
    </div>
  )
}
